import { defineAsyncComponent } from 'vue';
import { GlDisclosureDropdown, GlDisclosureDropdownItem } from '@gitlab/ui';
import { __ } from '~/locale';
import DiscussionReplyPlaceholder from './discussion_reply_placeholder.vue';
import ResolveDiscussionButton from './resolve_discussion_button.vue';
import ResolveWithIssueButton from './discussion_resolve_with_issue_button.vue';
export default {
    name: 'DiscussionActions',
    components: {
        DiscussionReplyPlaceholder,
        ResolveDiscussionButton,
        ResolveWithIssueButton,
        GlDisclosureDropdown,
        GlDisclosureDropdownItem,
        ResolveWithDuoDropdownItem: defineAsyncComponent(()=>import('ee_component/notes/components/resolve_with_duo_dropdown_item.vue'))
    },
    props: {
        discussion: {
            type: Object,
            required: true
        },
        isResolving: {
            type: Boolean,
            required: true
        },
        resolveButtonTitle: {
            type: String,
            required: true
        },
        resolveWithIssuePath: {
            type: String,
            required: false,
            default: ''
        },
        // eslint-disable-next-line vue/no-unused-properties -- shouldShowJumpToNextDiscussion is part of the component's public API.
        shouldShowJumpToNextDiscussion: {
            type: Boolean,
            required: true
        },
        sourceBranch: {
            type: String,
            required: false,
            default: ''
        },
        iid: {
            type: [
                String,
                Number
            ],
            required: false,
            default: null
        },
        canResolveDiscussionsWithAi: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'resolve',
        'show-reply-form'
    ],
    data () {
        return {
            isDuoLoading: false
        };
    },
    computed: {
        resolvableNotes () {
            return this.discussion.notes.filter((x)=>x.resolvable);
        },
        userCanResolveDiscussion () {
            return this.resolvableNotes.every((note)=>note.current_user?.can_resolve_discussion);
        },
        showIssueButton () {
            return this.discussion.resolvable && !this.discussion.resolved && this.resolveWithIssuePath;
        },
        showSecondaryActionsDropdown () {
            return this.discussion.resolvable && !this.discussion.resolved && this.canResolveDiscussionsWithAi;
        },
        resolveWithIssueItem () {
            return {
                text: __('Resolve with new issue'),
                href: this.resolveWithIssuePath
            };
        }
    }
};
